import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";
import { beforeAfter } from "@/content/siteContent";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export default function BeforeAfter() {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const update = (clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(96, Math.max(4, pct)));
  };

  return (
    <section className="border-y border-metal bg-graphite py-24 md:py-32" data-testid="before-after-section">
      <div className="mx-auto max-w-5xl px-5 md:px-8">
        <SectionHeading
          chapter={beforeAfter.chapter}
          microtitle={beforeAfter.microtitle}
          titleA={beforeAfter.titleA}
          titleB={beforeAfter.titleB}
          highlightWord={beforeAfter.highlightWord}
          description={beforeAfter.description}
        />

        <Reveal>
          <div
            ref={ref}
            className="relative mx-auto aspect-[573/1000] w-full max-w-[430px] cursor-ew-resize touch-none select-none overflow-hidden rounded-[20px] border border-metal"
            style={{ boxShadow: "var(--shadow-industrial)" }}
            onPointerDown={(e) => {
              e.currentTarget.setPointerCapture(e.pointerId);
              update(e.clientX);
            }}
            onPointerMove={(e) => e.buttons === 1 && update(e.clientX)}
            data-testid="before-after-slider"
          >
            <img src={beforeAfter.after} alt="Depois da higienização" loading="lazy" className="absolute inset-0 h-full w-full object-cover" draggable={false} />
            <img
              src={beforeAfter.before}
              alt="Antes da higienização"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
              style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
              draggable={false}
            />

            <span className="absolute left-5 top-5 rounded-full border border-metal bg-ink/85 px-4 py-1.5 font-display text-[0.62rem] font-extrabold tracking-[0.2em] text-mist backdrop-blur-sm">
              {beforeAfter.beforeLabel}
            </span>
            <span className="absolute right-5 top-5 rounded-full bg-brand px-4 py-1.5 font-display text-[0.62rem] font-extrabold tracking-[0.2em] text-ink">
              {beforeAfter.afterLabel}
            </span>

            <div className="absolute inset-y-0 w-[2px] bg-brand" style={{ left: `${pos}%` }} />
            <div
              className="medallion absolute top-1/2 -translate-x-1/2 -translate-y-1/2"
              style={{ left: `${pos}%`, width: 52, height: 52 }}
              data-testid="before-after-handle"
            >
              <div className="medallion-inner">
                <ChevronsLeftRight className="h-5 w-5 text-brand" />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
